import { CompanyPastHolds, CompanyUpcomingHolds } from '@features';
import { Stack } from '@mantine/core';

export const CompanyDetailsHoldsPage: React.FC = () => {
  return (
    <Stack py="md" gap="xl">
      <CompanyUpcomingHolds />
      <CompanyPastHolds />
    </Stack>
  );
};
